<template>
  <div class="shop-content">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <div class="content">
      <p>共为您找到{{total}}个商品</p>
      <van-list v-model="loading" :finished="finished" finished-text="已加载全部商品" @load="onReachBottom">
        <good-grid v-if="!isEmpty" :list.sync="goodsList"></good-grid>
        <emptyData v-if="isEmpty" message="暂无商品"></emptyData>
      </van-list>
    </div>
  </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import GoodGrid from '@/components/business/GoodGrid'
import EmptyData from '@/components/business/EmptyData'
import { getPrivilegeGoodsList } from '@/api/good'

export default {
  name : 'goodsList',
  components : {PhHeader,GoodGrid,EmptyData},
  data(){
    return{
      goodsList: [],
      page: 1,
      pagecount: 10,
      pageTotal: 0,
      total: 0,
      loading: false,
      finished: false,
      isEmpty: false,
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    },
  },
  created(){
    this.getData(true)
  },  
  methods:{
    // 获取数据
    getData (refresh) {
      this.Loading = false;
      this.isEmpty = false;
      this.isBottom = false
      var criteria = {
        userToken: this.token,
        privilegeId: this.$route.params.copid,
        pageIndex: this.page,
        pageSize: 20
      }
      getPrivilegeGoodsList(criteria).then(res => {
        if (refresh) {
          this.goodsList = res.result || []
        } else {
          this.goodsList = [...this.goodsList, ...res.result]
        }

        this.total = res.total
        this.pageTotal = res.pageCount
        
        if (this.goodsList.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.loading = false
      }).catch(error => {
        this.$toast(error)
      })
    },
    // 加载更多
    onReachBottom () {
      this.loading = true
      if(this.goodsList.length > 0) {
        if (this.page > this.pageTotal) { // 已经到底部
          this.finished = true
        }
      }
      this.page++
      setTimeout(() => {
        this.getData()
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.shop-content {
  .content{
    padding:0 24px;
    margin-top: 1.5rem;
    p{
      padding-left: 24px;
      font-size:20px;
      font-weight:400;
      color:rgba(153,153,153,1);
    }
  }
}
</style>